import { EnumType } from "./enums";

export const FEDERAL_EMPLOYEE_LABEL = { label: 'Federal Employee', localizedLabel: 'Federal Employee', value: 0 };
export const STATE_EMPLOYEE_LABEL = { label: 'State Employee', localizedLabel: 'State Employee', value: 1 };
export const LOCAL_EMPLOYEE_LABEL = { label: 'Local Employee', localizedLabel: 'Local Employee', value: 2 };

export const RESPONDER_ROLES_CONST: readonly EnumType[] = [
    FEDERAL_EMPLOYEE_LABEL,
    STATE_EMPLOYEE_LABEL,
    LOCAL_EMPLOYEE_LABEL,
    { label: 'Volunteer', localizedLabel: 'Volunteer', value: 3 },
    { label: 'Contractor', localizedLabel: 'Contractor', value: 4 },
    { label: 'Military', localizedLabel: 'Military', value: 5 },
    { label: 'Other', localizedLabel: 'Other', value: 6 }
] as const;

export const RESPONDER_STATUS_PENDING = { label: 'Pending', localizedLabel: 'Pending', value: 0 };
export const RESPONDER_STATUS_APPROVED = { label: 'Approved', localizedLabel: 'Approved', value: 1 };
export const RESPONDER_STATUS_CHECKED_IN = { label: 'Checked In/Staged', localizedLabel: 'Checked In/Staged', value: 2 };
export const RESPONDER_STATUS_IN_TRANSIT = { label: 'In Transit', localizedLabel: 'In Transit', value: 3 };
export const RESPONDER_STATUS_DEMOBILIZED = { label: 'Demobilized', localizedLabel: 'Demobilized', value: 4 };
export const RESPONDER_STATUS_DENIED = { label: 'Denied', localizedLabel: 'Denied', value: 5 };
export const RESPONDER_STATUS_ASSIGNED = { label: 'Assigned', localizedLabel: 'Assigned', value: 6 };

export const RESPONDER_STATUS_CONST: readonly EnumType[] = [
    RESPONDER_STATUS_PENDING,
    RESPONDER_STATUS_APPROVED,
    RESPONDER_STATUS_CHECKED_IN,
    RESPONDER_STATUS_IN_TRANSIT,
    RESPONDER_STATUS_ASSIGNED,
    RESPONDER_STATUS_DEMOBILIZED,
    RESPONDER_STATUS_DENIED
] as const;

export const RESPONDER_STATUS_FORM: readonly EnumType[] = [
    RESPONDER_STATUS_CHECKED_IN,
    RESPONDER_STATUS_IN_TRANSIT,
    RESPONDER_STATUS_ASSIGNED,
    RESPONDER_STATUS_DEMOBILIZED
] as const;

export const RESPONDER_STATUS_FILTER: readonly EnumType[] = [
    RESPONDER_STATUS_CHECKED_IN,
    RESPONDER_STATUS_IN_TRANSIT,
    RESPONDER_STATUS_ASSIGNED,
] as const;

export const RESPONDER_STATUS = {
    PENDING: RESPONDER_STATUS_PENDING.value,
    APPROVED: RESPONDER_STATUS_APPROVED.value,
    CHECKED_IN: RESPONDER_STATUS_CHECKED_IN.value,
    IN_TRANSIT: RESPONDER_STATUS_IN_TRANSIT.value,
    ASSIGNED: RESPONDER_STATUS_ASSIGNED.value,
    DEMOBILIZED: RESPONDER_STATUS_DEMOBILIZED.value,
    DENIED: RESPONDER_STATUS_DENIED.value
} as const;

export const USR_TEAMS = [
    { label: 'Not Applicable', localizedLabel: 'Not Applicable', value: 0 },
    ...Array.from({ length: 28 }, (_, i) => ({
        label: `Team ${i + 1}`,
        localizedLabel: `Team ${i + 1}`,
        value: i + 1
    }))
] as const;

export const MEAL_ACCESS_CONST: readonly EnumType[] = [
    { label: 'Full Access', localizedLabel: 'Full Access', value: 0 },
    { label: 'Per Diem No Access', localizedLabel: 'Per Diem No Access', value: 1 },
    { label: 'Reimburse No Access', localizedLabel: 'Reimburse No Access', value: 2 },
    { label: 'Other', localizedLabel: 'Other', value: 3 }
] as const;